// Règles de mot de passe et schémas d'authentification, communs au serveur et au front
// (écran de changement forcé : règles validées en direct, jauge à 4 segments).
import { z } from 'zod';

export const MIN_PASSWORD_LENGTH = 12;
/** Longueur qui vaut un point de plus à la jauge. */
export const LONG_PASSWORD_LENGTH = 16;

export interface PasswordRule {
  id: 'length' | 'case' | 'digit';
  label: string;
  test: (password: string) => boolean;
}

export const PASSWORD_RULES: readonly PasswordRule[] = [
  { id: 'length', label: `${MIN_PASSWORD_LENGTH} caractères minimum`, test: (password) => [...password].length >= MIN_PASSWORD_LENGTH },
  { id: 'case', label: 'Une majuscule et une minuscule', test: (password) => /\p{Lu}/u.test(password) && /\p{Ll}/u.test(password) },
  { id: 'digit', label: 'Un chiffre', test: (password) => /\d/.test(password) },
];

export function isStrongPassword(password: string): boolean {
  return PASSWORD_RULES.every((rule) => rule.test(password));
}

/** Score de la jauge, de 0 à 4 : règles remplies, plus 1 au-delà de 16 caractères. */
export function passwordScore(password: string): number {
  const passed = PASSWORD_RULES.filter((rule) => rule.test(password)).length;
  return passed + ([...password].length >= LONG_PASSWORD_LENGTH ? 1 : 0);
}

export const loginInputSchema = z.object({
  login: z.string().trim().toLowerCase().min(1).max(64),
  password: z.string().min(1).max(200),
});

export const passwordChangeSchema = z.object({
  currentPassword: z.string().min(1).max(200),
  newPassword: z.string().max(200).refine(isStrongPassword, { error: 'Mot de passe trop faible : 12 caractères, une majuscule, une minuscule et un chiffre' }),
});

export type Role = 'admin' | 'user';

export interface AccountDto {
  id: number;
  login: string;
  name: string;
  role: Role;
  mustChangePassword: boolean;
}
